import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import './styles.scss';
import Index from '../../views/Index';
import ThankYou from '../../views/ThankYou';
import Apply from '../../views/Apply';
import Recommend from '../../views/Recommend';

export default () => (
  <Router basename={process.env.REACT_APP_WEBAPP_URL || '/'}>
    <div className="app">
      <Header/>
      <main className="app__main">
        <Route exact={true} path="/" component={Index}/>
        <Route exact={true} path="/recommend" component={Recommend}/>
        <Route exact={true} path="/apply" component={Apply}/>
        <Route path="/recommend/thankyou" component={ThankYou}/>
        <Route path="/apply/thankyou" component={ThankYou} />
      </main>
      <Footer/>
    </div>
  </Router>
);
